import axios from "axios";
import { 
    CLEAR_MAIN_TABLE_PULPIT, GET_MAIN_TABLE_PULPIT_FAIL, SET_MAIN_TABLE_LOADING, GET_MAIN_TABLE_PULPIT,
    CLEAR_CODE_MAIN_TABLE, GET_FAIL_CODE_MAIN_TABLE, GET_LOADING_CODE_MAIN_TABLE, GET_CODE_MAIN_TABLE,
    CLEAR_FINANCE_TABLE_PULPIT, GET_FINANCE_TABLE_PULPIT_FAIL, SET_FINANCE_TABLE_LOADING, GET_FINANCE_TABLE_PULPIT,
    CLEAR_INDIRECT_COST_ROW, GET_INDIRECT_COST_ROW_FAIL, SET_INDIRECT_COST_ROW_LOADING, GET_INDIRECT_COST_ROW
} from '../actions/types'

import { refreshUser } from './authActions'
//pobieranie raportu getReport[numer], pobieranie od kodu do rozwijania getCode[numer]
const token =  localStorage.getItem("token");
const headers =  {
  'Accept': "application/json",
  "Content-Type": "application/json",
  "Authorization":`JWT ${token}`

}

//MAIN TABLE
export const getMainTable =(params)=>async dispatch => {
  dispatch({type: CLEAR_MAIN_TABLE_PULPIT})
  dispatch({ type: SET_MAIN_TABLE_LOADING })
  const config = {
      headers: headers,
      method: "get",
      url: `/api/pulpit1/`,
      params: params,
    };
    config.headers.Authorization = "JWT " + localStorage.getItem("token");

    try {
      const response = await axios(config);
      dispatch({
        type: GET_MAIN_TABLE_PULPIT,
        payload: response.data
      });
  
    }catch (err) {
      console.log("error: ", JSON.stringify(err))
      dispatch(refreshUser())
      dispatch({
        type: GET_MAIN_TABLE_PULPIT_FAIL,
      });
    }
}
export const getCodeMain =(params)=>async dispatch => {
  dispatch({ type: SET_MAIN_TABLE_LOADING })
  const config = {
      headers:headers,
      method: "get",
      url: `/api/pulpit1/`,
      params: params,
    };
    config.headers.Authorization = "JWT " + localStorage.getItem("token");
    try {
      const response = await axios(config);
      dispatch({
        type: GET_CODE_MAIN_TABLE,
        payload: response.data,
        code:params['number']
      });
  
    }catch (err) {
      console.log("error: ", JSON.stringify(err))
      dispatch(refreshUser())
      dispatch({
        type: GET_FAIL_CODE_MAIN_TABLE,
      });
    }
}
//tabele danych finansowych skumulowane 
export const getFinanceTable =(params)=>async dispatch => {
  dispatch({type: CLEAR_FINANCE_TABLE_PULPIT})
  dispatch({ type: SET_FINANCE_TABLE_LOADING })
  const config = {
      headers: headers,
      method: "get",
      url: `/api/pulpit2/`,
      params: params,
    };
    config.headers.Authorization = "JWT " + localStorage.getItem("token");
    try {
      const response = await axios(config);
      dispatch({
        type: GET_FINANCE_TABLE_PULPIT,
        payload: response.data
      });
  
    }catch (err) {
      console.log("error: ", JSON.stringify(err))
      dispatch(refreshUser())
      dispatch({
        type: GET_FINANCE_TABLE_PULPIT_FAIL,
      });
    }
}
///rozwijanie bezpośrednich kosztów
export const getIndirectCosts =(params)=>async dispatch => {
  dispatch({type: CLEAR_INDIRECT_COST_ROW})
  dispatch({ type: SET_INDIRECT_COST_ROW_LOADING })
  const config = {
      headers: headers,
      method: "get",
      url: `/api/pulpitbezposrednie/`,
      params: params,
    };
    config.headers.Authorization = "JWT " + localStorage.getItem("token");
    try {
      const response = await axios(config);
      dispatch({
        type: GET_INDIRECT_COST_ROW,
        payload: response.data
      });
  
    }catch (err) {
      console.log("error: ", JSON.stringify(err))
      dispatch(refreshUser())
      dispatch({
        type: GET_INDIRECT_COST_ROW_FAIL,
      });
    }
}
